var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCar = function SvgCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99 5.338 5.232 7.5h9.538l-.757-2.162c-.175-.5-.65-.838-1.18-.838H7.168c-.531 0-1.003.334-1.181.838zM3.504 7.9l1.069-3.06A2.75 2.75 0 0 1 7.169 3h5.662c1.169 0 2.21.737 2.597 1.84L16.5 7.9a3 3 0 0 1 1.5 2.6v5.75c0 .416-.334.75-.75.75a.75.75 0 0 1-.75-.75V14.5h-13v1.75c0 .416-.334.75-.75.75a.75.75 0 0 1-.75-.75V10.5c0-1.113.603-2.081 1.503-2.6M15 9H5a1.5 1.5 0 0 0-1.5 1.5V13h13v-2.5A1.5 1.5 0 0 0 15 9m-9.5 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m8 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
  })));
};
export default SvgCar;